import React, { useEffect, useMemo, useState } from "react";
import { FiArrowLeft, FiCalendar } from "react-icons/fi";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { getAuth } from "../../services/localStorage";
import { API_ENDPOINT } from "../../services/api";
import Labels from "../../services/apiLabels";
import { GET } from "../../constant/apiMethods";
import { getTimeSolts, formateTimeSlot } from "../../utils/formating";
import { isEmail, pickOptionId, unwrapList } from "../../utils/formValidation";
import {
  buildSchedulerDays,
  getOfficeTimmingMap,
} from "../../../utils/appointmentBooking";
import {
  authHeaders,
  errorText,
  isApiSuccess,
  listFromPayload,
  officeId,
  pick,
  readJson,
} from "../Offices/officeHelpers";
import { officeLabel } from "../InspectionUsers/inspectionUserHelpers";
import "../Offices/offices.css";

const OFFICES_PATH = "/dealers/dashbord/offices";

const OWNER_OPTIONS = [
  { title: "None", id: 7 },
  { title: "1", id: 1 },
  { title: "2", id: 2 },
  { title: "3", id: 3 },
  { title: "4", id: 4 },
  { title: "5 or more", id: 5 },
  { title: "Don't know", id: 6 },
];

const SERVICE_OPTIONS = [
  { title: "Full", id: 1 },
  { title: "Part", id: 2 },
  { title: "None", id: 3 },
  { title: "First not Due", id: 4 },
];

function optionLabel(item) {
  if (!item || typeof item !== "object") return "";
  return (
    item.brand_name ||
    item.display ||
    item.title ||
    item.name ||
    item.model_name ||
    ""
  );
}

async function fetchList(label) {
  const response = await fetch(API_ENDPOINT(label), {
    method: GET,
    headers: { "Content-Type": "application/json" },
  });
  const json = await readJson(response);
  return unwrapList(json);
}

function evaluationIdFromPayload(json) {
  const record = json?.data || json;
  if (Array.isArray(record)) {
    return pick(record[0], ["id", "pk", "evaluation_id"]);
  }
  if (record && typeof record === "object") {
    return pick(record, ["id", "pk", "evaluation_id"]);
  }
  return null;
}

function Field({ label, required, error, children }) {
  return (
    <div className="dd-field">
      <label>
        {label}
        {required ? <span className="dd-field__required"> *</span> : null}
      </label>
      {children}
      {error ? <p className="dd-password__error">{error}</p> : null}
    </div>
  );
}

function OfficeAppointmentForm() {
  const history = useHistory();
  const location = useLocation();
  const { officeId: officeIdParam } = useParams();
  const auth = getAuth();
  const listPath = `${OFFICES_PATH}/${officeIdParam}/appointments`;

  const [office, setOffice] = useState(location.state?.office || null);
  const [saving, setSaving] = useState(false);
  const [banner, setBanner] = useState({ type: "", text: "" });
  const [errors, setErrors] = useState({});
  const [client, setClient] = useState({
    name: "",
    email: "",
    postcode: "",
    mobile: "",
  });
  const [vehicle, setVehicle] = useState({
    reg_number: "",
    mileage: "",
    previous_owners: "",
    services_history: "",
    brand: null,
    model: null,
    fuel_type: null,
    year: null,
    variant: null,
  });
  const [options, setOptions] = useState({
    brands: [],
    models: [],
    fuels: [],
    years: [],
    variants: [],
  });
  const [loadingOptions, setLoadingOptions] = useState({
    brands: false,
    models: false,
    fuels: false,
    years: false,
    variants: false,
  });
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState("");

  useEffect(() => {
    if (!auth?.token || !officeIdParam) return undefined;
    if (
      location.state?.office &&
      String(officeId(location.state.office)) === String(officeIdParam)
    ) {
      setOffice(location.state.office);
      return undefined;
    }
    let cancelled = false;
    fetch(API_ENDPOINT(Labels.office_listing), {
      headers: authHeaders(auth.token),
    })
      .then((response) =>
        readJson(response).then((json) => ({ response, json }))
      )
      .then(({ response, json }) => {
        if (cancelled || !isApiSuccess(response, json)) return;
        const match = listFromPayload(json).find(
          (item) => String(officeId(item)) === String(officeIdParam)
        );
        if (match) setOffice(match);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [auth?.token, officeIdParam, location.state]);

  useEffect(() => {
    let cancelled = false;
    setLoadingOptions((prev) => ({ ...prev, brands: true }));
    fetchList(Labels.brands)
      .then((list) => {
        if (!cancelled) setOptions((prev) => ({ ...prev, brands: list }));
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingOptions((prev) => ({ ...prev, brands: false }));
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const schedulerDays = useMemo(
    () => (office ? buildSchedulerDays(office) : []),
    [office]
  );

  useEffect(() => {
    if (!selectedDay && schedulerDays.length) {
      setSelectedDay(schedulerDays[0]);
      setSelectedSlot("");
    }
  }, [schedulerDays, selectedDay]);

  const slots = useMemo(() => {
    if (!selectedDay) return [];
    const timing = getOfficeTimmingMap(office)[selectedDay.dayId];
    const start = timing?.start || selectedDay.start;
    const end = timing?.end || selectedDay.end;
    const today = new Date();
    const isToday = selectedDay.dateNum === today.toISOString().slice(0, 10);
    return getTimeSolts(start, end, isToday) || [];
  }, [office, selectedDay]);

  const loadChain = async (kind, label, clear) => {
    setLoadingOptions((prev) => ({ ...prev, [kind]: true }));
    setOptions((prev) => ({ ...prev, ...clear, [kind]: [] }));
    try {
      const list = await fetchList(label);
      setOptions((prev) => ({ ...prev, [kind]: list }));
    } finally {
      setLoadingOptions((prev) => ({ ...prev, [kind]: false }));
    }
  };

  const onBrand = (item) => {
    setVehicle((prev) => ({
      ...prev,
      brand: item,
      model: null,
      fuel_type: null,
      year: null,
      variant: null,
    }));
    const id = pickOptionId(item);
    if (id) {
      loadChain("models", `${Labels.car_models}${id}/`, {
        fuels: [],
        years: [],
        variants: [],
      });
    }
  };

  const onModel = (item) => {
    setVehicle((prev) => ({
      ...prev,
      model: item,
      fuel_type: null,
      year: null,
      variant: null,
    }));
    const id = pickOptionId(item);
    if (id) {
      loadChain("fuels", `${Labels.car_fuel_types}${id}/`, {
        years: [],
        variants: [],
      });
    }
  };

  const onFuel = (item) => {
    setVehicle((prev) => ({
      ...prev,
      fuel_type: item,
      year: null,
      variant: null,
    }));
    const id = pickOptionId(item);
    if (id) {
      loadChain("years", `${Labels.car_years}${id}/`, { variants: [] });
    }
  };

  const onYear = (item) => {
    setVehicle((prev) => ({ ...prev, year: item, variant: null }));
    const id = pickOptionId(item);
    if (id) loadChain("variants", `${Labels.car_variants}${id}/`, {});
  };

  const selectFrom = (list, setter) => (e) => {
    const match = list.find(
      (item) => String(pickOptionId(item)) === e.target.value
    );
    if (match) setter(match);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = {};
    if (!client.name.trim()) next.name = "Required";
    if (!isEmail(client.email)) next.email = "Enter a valid email.";
    if (!client.postcode.trim()) next.postcode = "Required";
    if (!client.mobile.trim()) next.mobile = "Required";
    if (!vehicle.reg_number.trim()) next.reg_number = "Required";
    if (!vehicle.mileage.trim()) next.mileage = "Required";
    if (!vehicle.previous_owners) next.previous_owners = "Required";
    if (!vehicle.services_history) next.services_history = "Required";
    if (!pickOptionId(vehicle.variant)) next.variant = "Select the vehicle.";
    if (!selectedDay?.dateNum) next.day = "Choose a day.";
    if (!selectedSlot) next.slot = "Choose a time.";
    setErrors(next);
    if (Object.keys(next).length) {
      setBanner({
        type: "error",
        text: "Complete the client, vehicle, and appointment details.",
      });
      return;
    }
    if (!auth?.token) {
      setBanner({ type: "error", text: "Please sign in again." });
      return;
    }

    setSaving(true);
    setBanner({ type: "", text: "" });
    try {
      const evalResponse = await fetch(
        API_ENDPOINT(Labels.evaluation_create),
        {
          method: "POST",
          headers: authHeaders(auth.token, true),
          body: JSON.stringify({
            car: pickOptionId(vehicle.variant),
            Mileage: vehicle.mileage.trim(),
            reg_number: vehicle.reg_number.trim().toUpperCase(),
            Previous_owners: Number(vehicle.previous_owners),
            Service_history: Number(vehicle.services_history),
            Website_user: client.name.trim(),
            Email: client.email.trim(),
            Postcode: client.postcode.trim(),
            Mobile_number: client.mobile.trim(),
          }),
        }
      );
      const evalJson = await readJson(evalResponse);
      if (!isApiSuccess(evalResponse, evalJson)) {
        throw new Error(errorText(evalJson, "Could not create the evaluation."));
      }
      const evaluationPk = evaluationIdFromPayload(evalJson);
      if (!evaluationPk) {
        throw new Error("Evaluation was created, but no id was returned.");
      }

      const officePk = officeId(office) || officeIdParam;
      const apptResponse = await fetch(
        API_ENDPOINT(Labels.appointment_create),
        {
          method: "POST",
          headers: authHeaders(auth.token, true),
          body: JSON.stringify({
            evaluation: evaluationPk,
            office: Number(officePk) || officePk,
            time_selected: selectedSlot,
            date_selected: selectedDay.dateNum,
            date_applied: selectedDay.dateNum,
            Address: pick(office, ["Address", "address"]),
          }),
        }
      );
      const apptJson = await readJson(apptResponse);
      if (!isApiSuccess(apptResponse, apptJson)) {
        throw new Error(
          errorText(
            apptJson,
            "The evaluation was saved, but the appointment could not be booked."
          )
        );
      }

      history.push({
        pathname: listPath,
        state: { office, notice: "Client evaluation appointment booked." },
      });
    } catch (err) {
      setBanner({
        type: "error",
        text: err?.message || "Could not book this appointment.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dd-section dd-offices">
      <form className="dd-form dd-offices__form" onSubmit={handleSubmit} noValidate>
        <div className="dd-arb-intro">
          <span className="dd-arb-intro__badge" aria-hidden>
            <FiCalendar size={18} />
          </span>
          <div>
            <h2>Book for a client</h2>
            <p>
              Create a vehicle evaluation and book the inspection at{" "}
              {officeLabel(office)} on the client’s behalf.
            </p>
          </div>
        </div>

        {banner.text ? (
          <p
            className={
              banner.type === "success"
                ? "dd-password__hint"
                : "dd-password__error"
            }
            role="status"
          >
            {banner.text}
          </p>
        ) : null}

        <section className="dd-book-section">
          <h3>Client</h3>
          <div className="dd-form-grid">
            <Field label="Name" required error={errors.name}>
              <input
                value={client.name}
                onChange={(e) =>
                  setClient((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </Field>
            <Field label="Mobile" required error={errors.mobile}>
              <input
                value={client.mobile}
                onChange={(e) =>
                  setClient((prev) => ({ ...prev, mobile: e.target.value }))
                }
              />
            </Field>
            <Field label="Email" required error={errors.email}>
              <input
                type="email"
                value={client.email}
                onChange={(e) =>
                  setClient((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </Field>
            <Field label="Postcode" required error={errors.postcode}>
              <input
                value={client.postcode}
                onChange={(e) =>
                  setClient((prev) => ({ ...prev, postcode: e.target.value }))
                }
              />
            </Field>
          </div>
        </section>

        <section className="dd-book-section">
          <h3>Vehicle</h3>
          <div className="dd-form-grid">
            <Field label="Registration" required error={errors.reg_number}>
              <input
                value={vehicle.reg_number}
                onChange={(e) =>
                  setVehicle((prev) => ({
                    ...prev,
                    reg_number: e.target.value.toUpperCase(),
                  }))
                }
              />
            </Field>
            <Field label="Mileage" required error={errors.mileage}>
              <input
                value={vehicle.mileage}
                onChange={(e) =>
                  setVehicle((prev) => ({ ...prev, mileage: e.target.value }))
                }
              />
            </Field>
            <Field label="Brand" required error={errors.variant}>
              <select
                value={pickOptionId(vehicle.brand)}
                disabled={loadingOptions.brands}
                onChange={selectFrom(options.brands, onBrand)}
              >
                <option value="">
                  {loadingOptions.brands ? "Loading…" : "Select brand"}
                </option>
                {options.brands.map((item, index) => (
                  <option key={pickOptionId(item) || index} value={pickOptionId(item)}>
                    {optionLabel(item)}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Model" required>
              <select
                value={pickOptionId(vehicle.model)}
                disabled={!vehicle.brand || loadingOptions.models}
                onChange={selectFrom(options.models, onModel)}
              >
                <option value="">
                  {loadingOptions.models ? "Loading…" : "Select model"}
                </option>
                {options.models.map((item, index) => (
                  <option key={pickOptionId(item) || index} value={pickOptionId(item)}>
                    {optionLabel(item)}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Fuel type" required>
              <select
                value={pickOptionId(vehicle.fuel_type)}
                disabled={!vehicle.model || loadingOptions.fuels}
                onChange={selectFrom(options.fuels, onFuel)}
              >
                <option value="">
                  {loadingOptions.fuels ? "Loading…" : "Select fuel type"}
                </option>
                {options.fuels.map((item, index) => (
                  <option key={pickOptionId(item) || index} value={pickOptionId(item)}>
                    {optionLabel(item)}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Year" required>
              <select
                value={pickOptionId(vehicle.year)}
                disabled={!vehicle.fuel_type || loadingOptions.years}
                onChange={selectFrom(options.years, onYear)}
              >
                <option value="">
                  {loadingOptions.years ? "Loading…" : "Select year"}
                </option>
                {options.years.map((item, index) => (
                  <option key={pickOptionId(item) || index} value={pickOptionId(item)}>
                    {optionLabel(item)}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Variant" required>
              <select
                value={pickOptionId(vehicle.variant)}
                disabled={!vehicle.year || loadingOptions.variants}
                onChange={selectFrom(options.variants, (item) =>
                  setVehicle((prev) => ({ ...prev, variant: item }))
                )}
              >
                <option value="">
                  {loadingOptions.variants ? "Loading…" : "Select variant"}
                </option>
                {options.variants.map((item, index) => (
                  <option key={pickOptionId(item) || index} value={pickOptionId(item)}>
                    {optionLabel(item)}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Previous owners" required error={errors.previous_owners}>
              <select
                value={vehicle.previous_owners}
                onChange={(e) =>
                  setVehicle((prev) => ({
                    ...prev,
                    previous_owners: e.target.value,
                  }))
                }
              >
                <option value="">Select</option>
                {OWNER_OPTIONS.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Service history" required error={errors.services_history}>
              <select
                value={vehicle.services_history}
                onChange={(e) =>
                  setVehicle((prev) => ({
                    ...prev,
                    services_history: e.target.value,
                  }))
                }
              >
                <option value="">Select</option>
                {SERVICE_OPTIONS.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </Field>
          </div>
        </section>

        <section className="dd-book-section">
          <h3>Inspection appointment</h3>
          <p className="dd-muted">
            Centre is fixed to {officeLabel(office)}. Choose a day and time from
            this office’s hours.
          </p>
          {errors.day || errors.slot ? (
            <p className="dd-password__error">{errors.day || errors.slot}</p>
          ) : null}
          {!schedulerDays.length ? (
            <p className="dd-password__error">
              This office has no opening hours yet. Add hours before booking.
            </p>
          ) : (
            <>
              <div className="dd-book-days" aria-label="Available days">
                {schedulerDays.map((day) => (
                  <button
                    type="button"
                    key={day.dateNum}
                    className={`dd-book-days__btn${
                      selectedDay?.dateNum === day.dateNum ? " is-selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedDay(day);
                      setSelectedSlot("");
                    }}
                  >
                    <span>{day.day}</span>
                    <strong>{day.date}</strong>
                  </button>
                ))}
              </div>
              <div className="dd-book-slots" aria-label="Available time slots">
                {slots.length ? (
                  slots.map((slot) => (
                    <button
                      type="button"
                      key={slot}
                      className={`dd-book-slots__btn${
                        selectedSlot === slot ? " is-selected" : ""
                      }`}
                      onClick={() => setSelectedSlot(slot)}
                    >
                      {formateTimeSlot(slot)}
                    </button>
                  ))
                ) : (
                  <p className="dd-muted">No time slots on this day.</p>
                )}
              </div>
            </>
          )}
        </section>

        <div className="dd-btn-row">
          <button
            type="button"
            className="dd-btn dd-btn--ghost"
            onClick={() => history.push({ pathname: listPath, state: { office } })}
          >
            <FiArrowLeft size={16} aria-hidden />
            Back
          </button>
          <button type="submit" className="dd-btn dd-btn--primary" disabled={saving}>
            {saving ? "Booking…" : "Book appointment"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default OfficeAppointmentForm;
